export default __webpack_public_path__ + "static/media/github.a8fc9d94.png";